<mat-card class="billing-card">
  <mat-card-content>
    <div class="mat-headline-4" i18n="@@billing">Billing</div>
    <form [formGroup]="billingForm" class="mt-30">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@annualFee">Annual fee</mat-label>
        <input formControlName="annualFee" matInput disabled id="annualFee" name="annualFee"/>
      </mat-form-field>
    </form>
    <div class="d-flex mt-30">
      <button data-testid="add_promotions_button" class="w-100 mr-16" mat-raised-button color="accent" i18n="@@buyWithCard" (click)="buyWithCard()">Buy with card</button>
      <div data-testid="paypal_button" class="w-100" id="paypal-checkout-btn"></div>
    </div>
  </mat-card-content>
</mat-card>
